import { IKeyValueHooks, IKeyValueSynchronous } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { APCourse } from '../../../../../global/builders/ap_course_builder';

export interface IAPCourseSearchDatasource
  extends IDatasource<APCourse>,
    IKeyValueSynchronous<APCourse>,
    IKeyValueHooks<APCourse> {}

angular
  .module('capability-ng-academic-planner')
  .factory('ngAPCourseSearchDatasource', (): IAPCourseSearchDatasource => {
    return new Datasource<APCourse>({
      builderType: APCourse,
      updateMode: 'merge'
    }).addHooks({
      $preWrite: (db: Datasource<APCourse>) => {
        _4.forEach(db, (course: APCourse, index) => {
          course['__searchRank'] = index;
        });
        return db;
      }
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/planner_search/course_search/datasources/ap_course_search_datasource.ts